import { useToggleState } from '@cian/react-utils';
import { Button, ModalWindow, useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { FactoidItem, FactoidsList, ModalFactoidsList } from 'shared/components/FactoidsList';
import { selectHouseFactoids } from 'shared/selectors/houseInfo';
import { MAX_VISIBLE_FACTOIDS, SHOW_MORE_BUTTON_PROPS } from './constants';
import { getFactoidsViewByDeviceType, renderFactoids } from './utils';
import { useEffect } from 'react';
import { trackAllFactoidsOpen } from './tracking';

export const FactoidsContainer = () => {
  const factoids = useSelector(selectHouseFactoids);
  const { state: isAllFactoidsModalOpen, toggle: toggleAllFactoidsModalOpen } = useToggleState();
  const deviceType = useDeviceType();
  const buttonProps = SHOW_MORE_BUTTON_PROPS[deviceType];

  useEffect(() => {
    if (isAllFactoidsModalOpen) {
      trackAllFactoidsOpen();
    }
  }, [isAllFactoidsModalOpen]);

  if (!factoids.length) {
    return null;
  }

  return (
    <>
      <FactoidsList
        list={renderFactoids(factoids.slice(0, MAX_VISIBLE_FACTOIDS), FactoidItem)}
        showMoreButton={
          factoids.length > MAX_VISIBLE_FACTOIDS ? (
            <Button {...buttonProps} onClick={toggleAllFactoidsModalOpen}>
              Показать все параметры
            </Button>
          ) : null
        }
      />
      {isAllFactoidsModalOpen && (
        <ModalWindow
          open
          title="Параметры дома"
          content={<ModalFactoidsList list={getFactoidsViewByDeviceType(factoids, deviceType)} />}
          onClose={toggleAllFactoidsModalOpen}
          width="100%"
          maxWidth={928}
          fixed
        />
      )}
    </>
  );
};
